module.exports = __webpack_public_path__ + "img/data_icon2.ae4c896c.png";